import { render } from "./CodeGolfChallenges.vue?vue&type=template&id=389edbe8&scoped=true"
import script from "./CodeGolfChallenges.vue?vue&type=script&lang=js"
export * from "./CodeGolfChallenges.vue?vue&type=script&lang=js"

import "./CodeGolfChallenges.vue?vue&type=style&index=0&id=389edbe8&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389edbe8"]])

export default __exports__